/**
 * @ author kunnisser
 * @ date 2018/12/26
 * @ description: 设置mock数据接口
 */

import Axios from "axios";
import qs from "qs";

const TIMEOUT = 30e3;
// const FILETIMEOUT = 60e3;
const CancelToke = Axios.CancelToken;
const cancelReqs = [];
Axios.defaults.withCredentials = true;

const getMock = (url) => {
  return (params) => {
    return Axios.get(url, {
      params,
      cancelToken: new CancelToke((c) => {
        cancelReqs.push(c); // 注入cancelToke示例
      }),
      timeout: TIMEOUT,
      headers: {
        Authorization: window.sessionStorage.getItem("token"),
      },
    });
  };
};

const postMock = (url) => {
  return (params, locale) => {
    return Axios.post(url, qs.stringify(params), {
      cancelToken: new CancelToke((c) => {
        cancelReqs.push(c);
      }),
      timeout: TIMEOUT,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: window.sessionStorage.getItem("token"),
        locale: locale || window.sessionStorage.getItem("locale"),
      },
    }).catch((error) => {
      if (error.code === "ECONNABORTED") {
        // 自定义超时异常内容
        return Promise.reject("系统超时请重试");
      } else {
        return Promise.reject(error);
      }
    });
  };
};

const postJson = (url) => {
  return (params, locale) => {
    return Axios.post(url, params, {
      cancelToken: new CancelToke((c) => {
        cancelReqs.push(c);
      }),
      timeout: TIMEOUT,
      headers: {
        "Content-Type": "application/json",
        Authorization: window.sessionStorage.getItem("token"),
        locale: locale || window.sessionStorage.getItem("locale"),
      },
    });
  };
};

const getJson = (url) => {
  return (params, locale) => {
    return Axios.get(url, {
      params,
      cancelToken: new CancelToke((c) => {
        cancelReqs.push(c);
      }),
      timeout: TIMEOUT,
      headers: {
        "Content-Type": "application/json",
        Authorization: window.sessionStorage.getItem("token"),
        locale: locale || window.sessionStorage.getItem("locale"),
      },
    });
  };
};

// const fileMock = (url) => {
//   return (params) => {
//     return Axios.post(url, qs.stringify(params), {
//       timeout: FILETIMEOUT,
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded'
//       }
//     });
//   }
// }

// v1.0.1 api
const APP_URL = process.env.REACT_APP_API_URL;
const prefixFile = APP_URL;
const Prefix = `${APP_URL}/api`;
window.sessionStorage.setItem("prefixFile", prefixFile);
/** **omc接口调用** */
const getUserMenuList = postMock(`${Prefix}/user/userMenuList`); // 菜单接口
/** ***充电成功率**** */
// 根据城市查询
const getChargSuccessCity = postMock(`${Prefix}/city/charg/success/rate`);
// 根据城市交直流查询
const getChargSuccessCityType = postMock(`${Prefix}/city/type/charg/success/rate`);
// 根据渠道查询
const getAppkeySuccessRate = postMock(`${Prefix}/appkey/charg/success/rate`);
// 固件版本数据
const getChargSuccessVersionType = postMock(`${Prefix}/versiontype/charg/success/rate`);
// 跳枪成功率
const getChargSuccessEndCode = postMock(`${Prefix}/endcode/charg/success/rate`);
// 设备完好率-桩运营类型分析
const getStubOperationModeList = postMock(`${Prefix}/stub/operationMode`);
// 设备完好率-城市完好率分析
const getStubCitySuccessRateList = postMock(`${Prefix}/stub/city/successRate`);
// 设备查询-获取设备型号列表
const getModelNoList = postMock(`${Prefix}/stub/modelNoList`);

// 设备查询-获取固件型号列表
const getFrameWorkList = postMock(`${Prefix}/stub/frameWorkList`);
// 设备查询-获取固件版本列表
const getUpdateTypeList = postMock(`${Prefix}/stub/updateTypeList`);
// 设备查询-获取设备列表
const getStubInfoList = postMock(`${Prefix}/stub/stubInfoListApart`);
// 设备查询-获取全量设备列表（旧）
const getStubInfoListAll = postMock(`${Prefix}/stub/stubInfoList`);
// 地锁查询-获取地锁列表
const getLockInfoList = postMock(`${Prefix}/stub/lockInfoList`);
const getCostCfgList = postJson(`${prefixFile}/mtsV2/omc/costCfgList/qry`);

const findTenceCompanyList = postMock(`${Prefix}/tenceCompany/list`); // 查询质保供应商
const editOrAddCompany = postMock(`${Prefix}/tenceCompany/edit`); // 编辑新增质保供应商
const delTenceCompany = postMock(`${Prefix}/tenceCompany/del`); // 删除质保供应商
const batchChangeTenceInfo = postMock(`${Prefix}/tenceCompany/batchSet`); // 设置质保供应商

const findStubOpLogList = postMock(`${Prefix}/stuOpLog/list`); // 查询维修记录列表
const hpcLogDownList = postMock(`${Prefix}/hpcLogDown/list`); // 查询hpc日志下载记录
const delStubOpLog = postMock(`${Prefix}/stuOpLog/del`); // 删除维修记录
const upOrAddStubOpLog = postMock(`${Prefix}/stuOpLog/edit`); // 新增或编辑维修记录

// 挪桩设备查询
const queryStubGroupList = postJson(`${prefixFile}/mtsV2/shutDown/list/stubGroup`);

const geServiceCompanyListrOptions = getMock(
  `${prefixFile}/mtsV2/omc/ticketCustomerService/companyList`,
);
const getAuthUser = getMock(`${prefixFile}/auth/userList`);

const userManagerRegionList = getMock(`${prefixFile}/mtsV2/omc/region/userRegionList`);
const cityTypeList = getMock(`${prefixFile}/mtsV2/omc/region/cityTypeList`);
const endCodeStatusList = getMock(`${prefixFile}/mtsV2/omc/region/endCodeStatusList`);
const updateCityType = postJson(`${prefixFile}/mtsV2/omc/region/updateCityType`);
const updateEndCodeStatus = postJson(`${prefixFile}/mtsV2/omc/region/updateEndCodeStatus`);

const EventMonitorCfgList = postJson(`${prefixFile}/mtsV2/omc/monitorCfgList/qry`);
const updateEventMonitorCfg = postJson(`${prefixFile}/mtsV2/omc/monitorCfg/update`);
const autoEventMonitorCfg = postMock(`${prefixFile}/mtsV2/omc/monitorCfg/enable/update`);
const addMenu = postJson(`${prefixFile}/auth/addMenu`);
const costCfgStatus = postMock(`${prefixFile}/mtsV2/omc/costCfg/enable/update`);
const updateCostCfg = postJson(`${prefixFile}/mtsV2/omc/costCfg/update`);
const insertCostCfg = postJson(`${prefixFile}/mtsV2/omc/costCfg/insert`);

// 设备查询-状态日志
const getStubStatuLogList = postMock(`${Prefix}/stub/statusList`);
// 设备查询-订单列表
const getStubOrderInfoList = postMock(`${Prefix}/stub/orderInfoList`);
const orderInfoCountByStubIdList = postMock(`${Prefix}/stub/orderInfoCountByStubIdList`);
// 设备查询-订单详情
const getStubOrderDetailInfo = postMock(`${Prefix}/stub/orderDetailInfo`);
// 配置管理接口
const getPowerBoxList = postMock(`${Prefix}/powerBox/list`);
const bindModelInfo = postJson(`${prefixFile}/mtsV2/powerbox/bindModelInfo`);
const getPowerBoxDetail = postMock(`${Prefix}/powerBox/detail`);
// 获取电站列表
const getStubGroupList = postMock(`${Prefix}/stubGroup/list`);
// 获取枪温监控订单列表
const getTempMonitoringList = postMock(`${prefixFile}/stubTemp/query`);
// 导出（含充电数据）
const exportChargingData = postMock(`${Prefix}/stub/orderInfoExport`);
// 获取导出记录列表
const getExportRecordsList = postJson(`${prefixFile}/export/record/page`);
// 修改投建方备注
const updateStubRemark = postMock(`${Prefix}/stubGroup/updateRemark`);
// 更新桩的状态
const updateStubStatus = postMock(`${Prefix}/stub/statusSave`);
// 绑定地锁
const lockBind = postMock(`${Prefix}/stub/lock/bind`);
// 解绑地锁
const lockUnBind = postMock(`${Prefix}/stub/lock/unBind`);
// 睡眠或唤醒地锁
const lockSleepOrWake = postMock(`${Prefix}/stub/lock/lockStatus`);
const lockSleepOrWakeBatch = postMock(`${Prefix}/stub/lock/lockStatus/batch`);
// 降低地锁
const lowInfoLockUnBind = postMock(`${Prefix}/stub/lock/lowInfo`);
// 地锁是否支持续约
const lockOrderStatus = postMock(`${Prefix}/stub/lock/stubSave`);
// 地锁降锁
const parkingLockDown = (stubId) => {
  return postJson(`${prefixFile}/mtsV2/stub/parkingLock/down?stubId=${stubId}`);
};
// 地锁查询状态日志
const getLockStatusLogList = getMock(`${prefixFile}/mtsV2/stub/lockLog`);

const getDDuserList = postMock(`${Prefix}/user/ddUserList`); // 系统用户接口
const getUserList = postMock(`${Prefix}/user/userList`);
const getDepartmentList = getMock(`${Prefix}/user/ddDepartment/list`);
const getUserListFromDepartment = getMock(`${Prefix}/user/departmentUser/list`);
const addUserFromDing = postMock(`${Prefix}/user/departmentUser/add`);
// 用户角色
const getRoleList = postMock(`${Prefix}/user/role/List`);
const getPermissionList = postMock(`${Prefix}/permission/list`);
const deleteRole = postMock(`${Prefix}/role/del`);
const distributeRole = postMock(`${Prefix}/user/role/distribute`);

const editRole = postMock(`${Prefix}/edit/role`); // 新增或修改角色
const editPermission = postMock(`${Prefix}/edit/permission`);
const deletePermission = postMock(`${Prefix}/delete/permission`); // 删除权限

const orderHis = postMock(`${Prefix}/order/his`);
const orderHisNew = getMock(`${prefixFile}/mtsV2/order/his`);
const powermoduleHis = postMock(`${Prefix}/powerModuleInfoSplitByOrder/orderHis`);

// 更获取枪端列表
const getEquipmentList = postMock(`${Prefix}/equipment/list`);

// 创建任务
const addTask = postMock(`${Prefix}/task/add`);

// 更新任务
const updateTask = postMock(`${Prefix}/task/update`);

// 获取协议配置属性
const getStubCfgInfo = postMock(`${Prefix}/stub/cfg`);

// 删除桩配置属性
const deleteStubCfg = postMock(`${Prefix}/stub/cfg/delete`);

// 获取任务列表
const getTaskList = postMock(`${Prefix}/task/list`);

// 删除任务
const deleteTask = postMock(`${Prefix}/task/delete`);

// 电桩配置参数查询
const stubCfgInfo = postMock(`${Prefix}/stub/cfg/info`);
// hpc电桩配置参数查询
const hpcStubCfgInfo = postMock(`${Prefix}/stubHpc/cfg/info`);

// 电桩配置参数同步
const stubCfgSync = postMock(`${Prefix}/stub/cfg/sync`);
// 使用桩端配置
const cfgFromStub = postMock(`${Prefix}/cfg/from/stub`);
// 桩配置日志
const stubCfgRecord = postMock(`${Prefix}/stubCfgRecord`);
// 桩配置保存
const stubCfgSave = postMock(`${Prefix}/stubcfg/save`);
// hpc桩配置保存
const hpcStubCfgSave = postMock(`${Prefix}/hpcstubcfg/save`);

// 任务执行
const executeTask = postMock(`${Prefix}/task/execute`);

// 电桩配置操作履历
// const stubCfgRecord = postMock(Prefix + '/stub/cfg/record');

// 获取桩配置信息并封装返回给前端展示
const getStubCfgTableInfo = postMock(`${Prefix}/stub/cfg/tableInfo`);

// 获取任务执行后桩的配置结果
const getStubCfgResult = postMock(`${Prefix}/stub/cfg/result`);

// 命令下发
const stubCmd = postMock(`${Prefix}/stubCmd`);

// 获取充电订单详情
const getChargeOrderDetail = postMock(`${Prefix}/order/summary/detail`);

// 获取CRC异常列表
const getCRCExceptionList = postMock(`${Prefix}/crcExceptionStud`);

// 根据时间分组获取完好率数据
const geIntactRateByTimeDim = postMock(`${Prefix}/intactRate/geIntactRateByTimeDim`);

// 根据各维度获取设备完好率数据
const geIntactRateByTypeDim = postMock(`${Prefix}/intactRate/geIntactRateByTypeDim`);

// 根据各维度获取设备列表详情
const getStubListDetail = postMock(`${Prefix}/intactRate/stub/detail`);

// 模块列表页面
const powerModuleInfo = postMock(`${Prefix}/powerModuleInfo/list`);

// 模块列表页面
const getModuleMsgList = postMock(`${Prefix}/powerModuleInfo/msgList`);

// 模块列表页面
const getCodeNameList = postMock(`${Prefix}/status/code/nameList`);

// 故障上报页面
const stubErrorReport = postMock(`${Prefix}/stubFaultReported/list`);

// 事件监控页面
const monitoring = postMock(`${Prefix}/event/monitoring/list`);
// 故障等级
const stubFaultReportedlevelData = postMock(`${Prefix}/stubFaultReported/levelData`);

// 固件版本-获取升级履历  /stub/upgrade/log/list
const getUpgrade = postMock(`${Prefix}/stub/upgrade/log/list`);

// 固件版本-固件升级   /stub/upgrade
const upgrade = postMock(`${Prefix}/stub/upgrade`);
const getHPCLog = postMock(`${Prefix}/stub/hpcLogD`);

// 固件版本-获取桩固件信息  /stub/firmware/version/get
const getFirmwareVersion = postMock(`${Prefix}/stub/firmware/version/get`);

// 固件版本-获取固件类型  /stub/frameWork/list
const getFirmwareList = postMock(`${Prefix}/stub/frameWork/list`);
// 城市地区获取接口
const getCityList = postMock(`${Prefix}/city/list`);

// 电损  /api/electricalLoss/list
const electricalLoss = postMock(`${Prefix}/electricalLoss/list`);

// 地锁统计
const lockStatisticsList = postJson(`${prefixFile}/lockstatistics/showlockstatistics`);
// 绑定明细
const bindDetailList = postJson(`${prefixFile}/lockstatistics/lockStatisticsBrand`);

// 设备完好率部分-查询天完好率 api/rate/day/get
const getRateDay = postMock(`${Prefix}/rate/day/get`);
// 设备完好率部分-查询月完好率 api/rate/month/get
const getRateMonth = postMock(`${Prefix}/rate/month/get`);
// 设备完好率部分-查询桩群完好率 api/stubgroup/rate/get
const getStubGroupRate = postMock(`${Prefix}/stubgroup/rate/get`);
// 设备完好率部分-查询桩完好率 api/stub/rate/get
const getStubRate = postMock(`${Prefix}/stub/rate/get`);
// 近2个月装群数据
const twoMonthStation = postMock(`${Prefix}/two/month/rate/get`);
// 设备完好率导出
const indicatorExport = postMock(`${Prefix}/indicator/export`);

/// 1.4.1新增

// 事件监控——告警详情 /event/monitoring/log/list
const eventMonitoringDetail = postMock(`${Prefix}/event/monitoring/log/list`);
// 模块信息，故障日志查询  /powerModule/status
const powerModuleStatus = postMock(`${Prefix}/powerModule/status`);

/// /1.5.0新增
// 停止原因接口 /api/endCodeInfo
const endCodeInfo = postMock(`${Prefix}/endCodeInfo`);
// 平台日志接口
const aliGetLogs = postMock(`${Prefix}/log/aliGetLogs`);
// 平台日志类型接口 /api/log/aliListLogstore
const aliListLogstore = postMock(`${Prefix}/log/aliListLogstore`);
// 充电应用 /appKeyInfo
const appKeyInfo = postMock(`${Prefix}/appKeyInfo`);

// 1.5.0 看板接口
// 长期异常桩 /stubLongAbnormalList
const stubLongAbnormalList = postMock(`${Prefix}/stubLongAbnormalList`);

// 1:设备数据 /equipment/quantity/qry
const equipmentQry = postMock(`${Prefix}/equipment/quantity/qry`);
// 2:充电成功率 /success/rate/quantity/qry
const successQry = postMock(`${Prefix}/success/rate/quantity/qry`);
// 2：充电成功率 柱状图  /success/rate/trend/qry
const successRateQry = postMock(`${Prefix}/success/rate/trend/qry`);
// 3: 设备完好率 数据 equipment/intact/rate/quantity/qry
const intactRry = postMock(`${Prefix}/equipment/intact/rate/quantity/qry`);
// 3: 设备完好率 趋势 equipment/intact/rate/trend/qry
const intacttrend = postMock(`${Prefix}/equipment/intact/rate/trend/qry`);
// 4:电损数据查询  power/loss/quantity/qry
const powerlossQry = postMock(`${Prefix}/power/loss/quantity/qry`);
// 4:电损趋势查询
const powerlossTrend = postMock(`${Prefix}/power/loss/trend/qry`);
// 5:事件数据查询
const eventMonitoringQry = postMock(`${Prefix}/event/monitoring/quantity/qry`);
// 5:事件趋势查询
const eventMonitoringTrend = postMock(`${Prefix}/event/monitoring/trend/qry`);
// 6:故障数量查询
const faultQry = postMock(`${Prefix}/fault/report/quantity/qry`);
// 7:故障趋势查询
const faultTrend = postMock(`${Prefix}/fault/report/trend/qry`);

const queryTicketNumAndHours = postMock(`${Prefix}/fault/report/ticket/qry`); // 人效指标
const queryWorkEfficiency = postMock(`${Prefix}/fault/report/ticketWork/qry`); // 人效指标
const queryNewDeviceNum = postMock(`${Prefix}/device/num/qry`); // 新看板-设备统计数据
const queryNewDeviceStatus = postMock(`${Prefix}/device/status/qry`); // 新看板-设备状态数据
const queryLockNumQry = postMock(`${Prefix}/lock/num/qry`); // 新看板-地锁状态数据
const queryLockQuantity = getMock(`${APP_URL}/mtsV2/lock/quantity/qry`); // 新看板-获取公充地锁数据
const queryMaintainEquipments = getMock(`${APP_URL}/mtsV2/equipment/maintain/quantity/qry`); // 新看板-获取维护中设备数据
const querySuccessRate = getMock(`${APP_URL}/mtsV2/success/order/rate/qry`); // 新看板-获取充电成功率数据
const queryDeviceAreaNumQry = postMock(`${Prefix}/station/areaNum/qry`); // 新看板-设备信息-按区域合计
const queryOrderAreaNumQry = postMock(`${Prefix}/order/areaCount/qry`); // 新看板-设备信息-按区域合计
const queryOrderAreaNumCityListQry = postMock(`${Prefix}/order/areaCountList/qry`); // 新看板-设备信息-按区域-城市列表

const queryTicketAreaNumCityQry = postMock(`${Prefix}/ticket/areaCount/qry`); // 工单数据-工单弹窗区域统计数据
const queryTicketAreaNumListCityQry = postMock(`${Prefix}/ticket/areaCountList/qry`); // 工单数据-工单弹窗区域统计数据

const queryFaultAreaNumCityQry = postMock(`${Prefix}/fault/areaCount/qry`); // 工单数据-工单弹窗区域统计数据
const queryFaultAreaNumListCityQry = postMock(`${Prefix}/fault/areaCountList/qry`); // 工单数据-工单弹窗区域统计数据

const queryOrderCountDetail = getMock(`${prefixFile}/kanban/order/count/detail`); // 工单数据-订单列表明细
const queryOrderStub = getMock(`${prefixFile}/kanban/order/stub/qry`); // 工单数据-故障率TOP20设备终端查询

const queryFaultStationTop = getMock(`${prefixFile}/mtsV2/fault/station/report/top`); // 工单数据-故障场站 Top20 排名接口查询
const queryFaultTicketDetail = getMock(`${prefixFile}/mtsV2/fault/ticket/detail`); // 工单数据-故障（物料）工单详情查询
const queryFaultStationDetail = getMock(`${prefixFile}/mtsV2/fault/station/detail`); // 工单数据-故障工单场站详情查询

const queryDeviceAreaCityNumQry = postMock(`${Prefix}/station/cityNum/qry`); // 新看板-设备信息-按区域查询城市列表

const queryOrderBoardQry = postMock(`${Prefix}/order/areaCount/qry`); // 新看板-订单数据-订单弹窗区域统计数据

const queryOrderNewCountQry = postMock(`${Prefix}/order/count/qry`); // 新看板-订单信息-累计合计
const queryKanbanOrderNewCountQry = getMock(`${prefixFile}/kanban/order/fault/qry`); // 新看板-订单信息-累计合计

const queryTicketNewCountQry = postMock(`${Prefix}/ticket/count/qry`); // 新看板-工单信息-累计合计

const qryByTicketType = postMock(`${Prefix}/ticket/count/qryByTicketType`); // 新看板-工单信息-累计合计
const qryTicketNumByArea = postMock(`${Prefix}/ticket/count/qryByTicketArea`); // 新看板-工单信息-累计合计

const qryErrorNumByArea = postMock(`${Prefix}/fault/report/quantityNew/qry`); // 新看板-故障信息-累计合计

const qryErrorNumListByArea = postMock(`${Prefix}/fault/report/city/trendList/qry`); // 新看板-故障信息-趋势数据

const getFaultTypeTop = getMock(`${prefixFile}/mtsV2/fault/type/report/top`); // 电站运行看板-工单数据-故障类型TOP20排名

const getFaultStationTop = getMock(`${prefixFile}/mtsV2/fault/station/report/top`); // 电站运行看板-工单数据-故障场站TOP20排名

const getMaterialTop = getMock(`${prefixFile}/mtsV2/material/report/top`); // 电站运行看板-工单数据-投入物料TOP10排名

// 财务指标
const queryTicketCost = postMock(`${Prefix}/fault/report/ticketCost/qry`);

// 工单数量-工单类型等维度区分查询
const queryTicketNumByDim = postMock(`${Prefix}/fault/report/ticketTypeSome/qry`);

const cityRank = postMock(`${Prefix}/fault/report/cityRank/qry`); // 近30天城市排名

// 工单数量-工单类型等维度区分查询
const ticketTypeQry = postMock(`${Prefix}/fault/report/ticketType/qry`);

const getDepotStubInfoList = getMock(`${Prefix}/stub/depot/stubInfoList`); // 仓库设备信息查询列表
// 查询信号强度历史记录
const getSignalHistory = getMock(`${Prefix}/stub/signal`);
const getSignalHistoryNew = getMock(`${prefixFile}/mtsV2/list/singal`);
// 查询CP电压历史记录
const getCPVoltageHistory = getMock(`${prefixFile}/mtsV2/list/cpVoltage`);
// 查询状态码列表
const getStatusCodeList = getMock(`${Prefix}/status/code/list`);
// 查询物料列表
const getMaterialsTypeList = getMock(`${prefixFile}/mtsV2/qry/materials`);
// 删除物料
const delMaterials = getMock(`${prefixFile}/mtsV2/del/materials`);
// 查询用途列表
const getMaterialsUseList = getMock(`${prefixFile}/mtsV2/qry/materialsUse`);
// 删除用途
const deleteMaterialsUse = getMock(`${prefixFile}/mtsV2/delete/materialsUse`);
//  更新、增加用途
const addMaterialsUse = postJson(`${prefixFile}/mtsV2/add/materialsUse`);
// 编辑更新物料
const updateMaterialsType = getMock(`${prefixFile}/mtsV2/update/materials`);
// 更新状态码信息
const updateStatusCodeInfo = postMock(`${Prefix}/status/code`);
// 查询字典值
const getDicCodeList = getMock(`${Prefix}/dic/code/list`);
// 按月查询充电成功率趋势
const getChargeSuccessRateByMon = getMock(`${Prefix}/city/month/charge/success/rate`);
// 按天查询充电成功率趋势
const getChargeSuccessRateByDay = getMock(`${Prefix}/city/day/charge/success/rate`);
// 固件版本维度充电成功率趋势
const getChargeSuccessRateByFirmware = getMock(`${Prefix}/versiontype/charge/success/rate`);
// 地区维度停止原因占比
const getStopReason = getMock(`${Prefix}/endcode/city/charge/success/perc`);
// 设备充电成功率排行
const getStationOrEquRank = getMock(`${Prefix}/stub/charge/success/rank`);
// 电站充电成功率排行
const getStationRank = getMock(`${Prefix}/stubgroup/charge/success/rank`);

// 渠道排行
const getChanelRank = getMock(`${Prefix}/appkey/charge/success/rank`);
// 渠道
const getChanelRankList = getMock(`${Prefix}/appkey/charge/list/Appkey`);
// 电站充电成功率趋势
const getStationSuccessRate = getMock(`${Prefix}/stubgroup/charge/success/rate`);
// 设备充电成功率趋势
const getEquSuccessRate = getMock(`${Prefix}/stub/charge/success/rate`);
// 电站设备维度停止原因
const getStationOrEquStopReason = getMock(`${Prefix}/endcode/stub/charge/success/perc`);
// 设备诊断
const stubDiagnosis = getMock(`${Prefix}/diagnosis/stub`);
// 电站诊断
const stubGroupDiagnosis = getMock(`${Prefix}/diagnosis/stubgroup`);

// 电损系数更新
const electricalLossUpdate = postMock(`${Prefix}/stub/elecloss/update`);

// 固件备注更新
const updateFirmwareRemark = postMock(`${Prefix}/stub/firmware/updateFirmwareInfo`);
// 版本信息列表
const getVersionList = getMock(`${Prefix}/stub/firmware/version/list`);
// 固件状态操作
const updateFirmwareStatus = postMock(`${Prefix}/stub/firmware/version/update`);
// 新增固件型号和版本
const addFirmware = postMock(`${Prefix}/stub/firmware/version/save`);
// 获取固件型号列表
const getFirmwareList1 = getMock(`${Prefix}/stub/firmware/list`);
// 获取固件升级进度
const getFirmwareUpdateProgress = getMock(`${Prefix}/stub/firmware/version/get`);
const getHpcFirmwareUpdateProgress = getMock(`${Prefix}/stub/hpcLog/firmwareUpdate/get`);

// 获取HPC日志下载进度
const getHpcLogStatus = getMock(`${Prefix}/stub/hpcLog/status/get`);
// 1.7.0 新增接口
// 设备快速查询
// 远程复位
const stubRestart = getMock(`${Prefix}/stubRestart`);
// 远程解锁
const unlockConnector = getMock(`${Prefix}/unlockConnector`);
// 电站名称筛选
const stubGroupNameSearch = getMock(`${Prefix}/stubGroupByName/list`);
// 电站拓扑图列表
const stubGroupRelation = getMock(`${Prefix}/stubgroup/relation/list`);
// 获取最新固件版本号
const stubCmdFirmware = getMock(`${Prefix}/stubCmdFirmware`);
// 事件监控——新
const stubEventMonitoringNew = getMock(`${Prefix}/stub/event/monitoring/list`);
// 配电柜故障
const powerEventMonitoring = getMock(`${Prefix}/stub/event/power_monitoring/list`);
// 事件监控详情——新
const stubEventMonitoringDetailNew = getMock(`${Prefix}/stub/event/monitoring/log/list`);
// 修改事件状态
const eventStatusChange = getMock(`${Prefix}/stub/event/status/change`);
// 忽略故障上报
const ignoreFault = postMock(`${Prefix}/stub/event/status/ignore`);
// 基础信息
const stubDetailInfoApi = getMock(`${Prefix}/stub/detail`);
const getStubGroupDetail = getMock(`${Prefix}/stubGroup/detail`); // 场站信息
// 1.8.0 新增部分
// 订单强制停止
const orderForceStop = getMock(`${Prefix}/order/orderForceStop`);

// 上传文件
const uploadFileApi = postMock(`${prefixFile}/uploadFile.do`);
// 校验鉴权文件 api/stubcfg/filecrc/check
const checkJQfile = getMock(`${Prefix}/stubcfg/filecrc/check`);

// 登陆相关
const loginWithPasswordApi = postMock(`${APP_URL}/system/login/pc`);
const getCompanyListApi = postJson(`${APP_URL}/system/companyRegList`);
const refreshTokenApi = postJson(`${APP_URL}/system/refrehToken`);
// 1.6.0验证码接口
const getCode = postJson(`${APP_URL}/system/captcha/getCode`);
// 1.8.3
// 故障城市查询
const faultReportCityTrend = postMock(`${Prefix}/fault/report/city/trend/qry`);
// oss上传配置
const getOssConfigApi = getMock(`${prefixFile}/mtsV2/oss/signature/get`);
// 1.5.0新增接口
const addFirmwareModel = postMock(`${Prefix}/firmware/version/save`);

// 巡检保养统计列表
const getInspectionStatisticsApi = postJson(`${prefixFile}/mtsV2/ticketType/statistics/query`);
// 巡检保养统计列表-导出
const exportInspectionStatisticsApi = postJson(`${prefixFile}/mtsV2/ticketType/statistics/export`);

// 非直连订单列表-查询
const getUnDirectConnectOrderApi = postJson(`${prefixFile}/mtsV2/out/order/list`);

// 非直连订单列表-导出
const exportFileInfoApi = postJson(`${prefixFile}/mtsV2/out/order/export`);

//非直连订单列表-充电数据
const getUnDirectChargeInfo = postJson(`${prefixFile}/mtsV2/out/order/processHis`);

//非直连设备列表-查询
const getUnDirectConnectDeviceApi = postJson(`${prefixFile}/mtsV2/omc/out/stub/list`);

//非直连设备列表-状态日志
const getUnDirectStubStatusLogList = postJson(`${prefixFile}/mtsV2/omc/out/stub/status/list`);

//非直连设备列表-配置刷新
const getUnDirectStubConfigInfoList = postJson(`${prefixFile}/mtsV2/omc/out/stub/config/query`);

//非直连设备列表-配置信息-获取最新配置
const getUnDirectNewConfigInfo = postJson(
  `${prefixFile}/mtsV2/omc/out/stub/config/queryCmd/issued`,
);

//非直连设备列表-配置信息-修改配置--保存
const saveUnDirectConfigInfo = postJson(`${prefixFile}/mtsV2/omc/out/stub/config/update`);

//非直连设备列表-固件升级-获取固件版本
const getUnDirectFirmwareVersion = getJson(`${prefixFile}/mtsV2/omc/out/stub/firmware/version`);
//非直连设备列表-固件升级-获取最新固件信息
const getUnDirectNewFirmwareInfo = getJson(`${prefixFile}/mtsV2/omc/out/stub/firmware/refresh`);
//非直连设备列表-固件升级-保存
const saveUnDirectFirmwareInfo = postJson(`${prefixFile}/mtsV2/omc/out/stub/firmware/upgrade`);

//sso-login
const ssoLogin = postJson(`${prefixFile}/system/sso/login`);

export {
  getOssConfigApi,
  faultReportCityTrend,
  getUserMenuList,
  getChargSuccessCityType,
  getChargSuccessCity,
  getStubOperationModeList,
  getStubCitySuccessRateList,
  getAppkeySuccessRate,
  getChargSuccessVersionType,
  getChargSuccessEndCode,
  getDepartmentList,
  getUserListFromDepartment,
  addUserFromDing,
  getUserList,
  getPowerBoxList,
  getPowerBoxDetail,
  getRoleList,
  getPermissionList,
  deleteRole,
  editRole,
  prefixFile,
  cancelReqs,
  getDDuserList,
  distributeRole,
  getFrameWorkList,
  getModuleMsgList,
  getCodeNameList,
  getModelNoList,
  getUpdateTypeList,
  updateCityType,
  updateEndCodeStatus,
  userManagerRegionList,
  endCodeStatusList,
  cityTypeList,
  getLockInfoList,
  getStubInfoList,
  getStubInfoListAll,
  findTenceCompanyList,
  delStubOpLog,
  findStubOpLogList,
  upOrAddStubOpLog,
  hpcLogDownList,
  queryStubGroupList,
  editOrAddCompany,
  batchChangeTenceInfo,
  delTenceCompany,
  getCostCfgList,
  costCfgStatus,
  EventMonitorCfgList,
  updateEventMonitorCfg,
  addMenu,
  autoEventMonitorCfg,
  updateCostCfg,
  insertCostCfg,
  getStubStatuLogList,
  editPermission,
  getStubOrderDetailInfo,
  getStubGroupList,
  getTempMonitoringList,
  exportChargingData,
  getExportRecordsList,
  updateStubRemark,
  getStubOrderInfoList,
  orderHis,
  orderHisNew,
  powermoduleHis,
  orderInfoCountByStubIdList,
  lockBind,
  lowInfoLockUnBind,
  lockUnBind,
  lockSleepOrWake,
  lockSleepOrWakeBatch,
  lockOrderStatus,
  parkingLockDown,
  getLockStatusLogList,
  updateStubStatus,
  getEquipmentList,
  addTask,
  hpcStubCfgInfo,
  getStubCfgInfo,
  updateTask,
  deleteStubCfg,
  getTaskList,
  deleteTask,
  stubCfgInfo,
  stubCfgSync,
  cfgFromStub,
  stubCfgRecord,
  stubCfgSave,
  executeTask,
  hpcStubCfgSave,
  getStubCfgTableInfo,
  getStubCfgResult,
  stubCmd,
  getChargeOrderDetail,
  getCRCExceptionList,
  geIntactRateByTimeDim,
  geIntactRateByTypeDim,
  getStubListDetail,
  getStubGroupDetail,
  powerEventMonitoring,
  stubErrorReport,
  monitoring,
  stubFaultReportedlevelData,
  powerModuleInfo,
  getUpgrade,
  upgrade,
  getHPCLog,
  getFirmwareVersion,
  getFirmwareList,
  deletePermission,
  getCityList,
  electricalLoss,
  getRateDay,
  getRateMonth,
  getStubGroupRate,
  getStubRate,
  twoMonthStation,
  indicatorExport,
  eventMonitoringDetail,
  powerModuleStatus,
  endCodeInfo,
  aliListLogstore,
  aliGetLogs,
  appKeyInfo,
  equipmentQry,
  successQry,
  successRateQry,
  intactRry,
  intacttrend,
  powerlossQry,
  queryOrderBoardQry,
  qryByTicketType,
  qryErrorNumByArea,
  qryErrorNumListByArea,
  getFaultTypeTop,
  getFaultStationTop,
  getMaterialTop,
  qryTicketNumByArea,
  queryTicketNewCountQry,
  queryOrderNewCountQry,
  queryKanbanOrderNewCountQry,
  queryDeviceAreaCityNumQry,
  queryFaultAreaNumListCityQry,
  queryOrderCountDetail,
  queryOrderStub,
  queryFaultStationTop,
  queryFaultTicketDetail,
  queryFaultStationDetail,
  queryLockNumQry,
  queryLockQuantity,
  queryMaintainEquipments,
  querySuccessRate,
  queryDeviceAreaNumQry,
  powerlossTrend,
  queryOrderAreaNumQry,
  queryOrderAreaNumCityListQry,
  queryFaultAreaNumCityQry,
  queryTicketAreaNumListCityQry,
  queryTicketAreaNumCityQry,
  eventMonitoringQry,
  ticketTypeQry,
  eventMonitoringTrend,
  faultQry,
  queryTicketNumAndHours,
  queryWorkEfficiency,
  queryNewDeviceNum,
  queryNewDeviceStatus,
  geServiceCompanyListrOptions,
  getAuthUser,
  queryTicketCost,
  queryTicketNumByDim,
  cityRank,
  faultTrend,
  stubLongAbnormalList,
  getDepotStubInfoList,
  getSignalHistory,
  getSignalHistoryNew,
  getCPVoltageHistory,
  getStatusCodeList,
  getMaterialsTypeList,
  delMaterials,
  getMaterialsUseList,
  deleteMaterialsUse,
  addMaterialsUse,
  bindModelInfo,
  updateMaterialsType,
  updateStatusCodeInfo,
  getDicCodeList,
  getChargeSuccessRateByMon,
  getChargeSuccessRateByDay,
  getChargeSuccessRateByFirmware,
  getStopReason,
  getStationOrEquRank,
  getChanelRank,
  getStationSuccessRate,
  getChanelRankList,
  getEquSuccessRate,
  getStationOrEquStopReason,
  stubDiagnosis,
  stubGroupDiagnosis,
  getStationRank,
  electricalLossUpdate,
  updateFirmwareRemark,
  getVersionList,
  updateFirmwareStatus,
  getHpcLogStatus,
  unlockConnector,
  addFirmware,
  getFirmwareList1,
  getFirmwareUpdateProgress,
  getHpcFirmwareUpdateProgress,
  stubRestart,
  stubGroupNameSearch,
  stubGroupRelation,
  stubCmdFirmware,
  stubEventMonitoringNew,
  stubEventMonitoringDetailNew,
  eventStatusChange,
  ignoreFault,
  stubDetailInfoApi,
  orderForceStop,
  uploadFileApi,
  checkJQfile,
  loginWithPasswordApi,
  refreshTokenApi,
  getCompanyListApi,
  lockStatisticsList,
  bindDetailList,
  addFirmwareModel,
  getCode,
  getInspectionStatisticsApi,
  exportInspectionStatisticsApi,
  getUnDirectConnectOrderApi,
  getUnDirectConnectDeviceApi,
  getUnDirectStubStatusLogList,
  getUnDirectStubConfigInfoList,
  getUnDirectNewConfigInfo,
  saveUnDirectConfigInfo,
  getUnDirectChargeInfo,
  getUnDirectFirmwareVersion,
  getUnDirectNewFirmwareInfo,
  saveUnDirectFirmwareInfo,
  exportFileInfoApi,
  ssoLogin,
};



// WEBPACK FOOTER //
// ./src/AntD/fetch/fetchApi.js